// cart-gift-guard.js
// Blind Barrels – remove $0 included items when subscription is removed from cart.
// Spec: _specs/026-p1-high-priority-fixes.md (Issue #3)
//
// DEFENSE-IN-DEPTH: This guard runs client-side only. It is NOT a security
// boundary — a user who disables JavaScript or calls the Shopify AJAX API
// directly can bypass it. Server-side enforcement via Shopify Scripts (Plus
// feature) is recommended as a future hardening step.

(function () {
  if (window.bbGiftMode !== 'legacy') return;

  async function loadCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  async function update(cart) {
    const updates = {};

    // Detect subscription via variant ID (most reliable), _bb_plan_type (set by
    // addon-bundler.js), or legacy _bb_subscription property.
    var vc = window.bbVariantConfig || {};
    var subVariantIds = [vc.annualSub, vc.quarterlySub].filter(Boolean);
    // Only treat these as removable included gifts when no subscription exists.
    // This prevents accidental removal of normal catalog items if a third-party
    // script adds `_bb_included: yes` to unrelated products.
    var includedGiftVariantIds = [vc.annualGlasses, vc.quarterlyGlass, vc.bonusBox, vc.legacyGlass].filter(Boolean);

    var hasSubscription =
      cart.items.some(function(i) { return subVariantIds.includes(i.variant_id); }) ||
      cart.items.some(function(i) {
        var p = i.properties || {};
        return p._bb_subscription === 'annual' || p._bb_subscription === 'quarterly' ||
               p._bb_plan_type === 'annual'    || p._bb_plan_type === 'quarterly';
      });

    for (const item of cart.items) {
      var p = item.properties || {};
      const isIncluded = p._bb_included === 'yes';
      const hasGiftPlanMarker = p._bb_parent_plan === 'annual' || p._bb_parent_plan === 'quarterly';
      const isKnownIncludedGift = includedGiftVariantIds.includes(item.variant_id);

      if (isIncluded && !hasSubscription && (hasGiftPlanMarker || isKnownIncludedGift)) {
        updates[item.key] = 0;
      }
    }

    if (Object.keys(updates).length) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      window.location.reload();
    }
  }

  document.addEventListener('DOMContentLoaded', async () => {
    const cart = await loadCart();
    await update(cart);
  });
})();

